import { Grid, Typography } from "@mui/material";
import DownloadIcon from "../../../../assets/icons/results-action-download.svg";
import TalkIcon from "../../../../assets/icons/results-action-talk.svg";
import ShareIcon from "../../../../assets/icons/results-action-share.svg";
import QuestionsIcon from "../../../../assets/icons/results-action-questions.svg";
import TestResultsPageStyles from "./TestResultsPage.styles";

const WhatsNextBox = (props) => {
  const { smallMode } = props;
  const classes = TestResultsPageStyles();

  return (
    <Grid
      item
      sm={smallMode ? 4 : 12}
      className={`${smallMode ? classes.sideMenuContainer : ""}`}
    >
      <Grid container>
        <Grid item>
          <Grid container direction={"column"}>
            <Typography variant="h4_accent2">Your next actions</Typography>
            <Grid
              container
              direction="column"
              spacing={2}
              className={classes.nextActions}
            >
              <Grid
                item
                container
                spacing={2}
                alignItems="center"
                id="download-results"
              >
                <Grid item>
                  <img
                    src={DownloadIcon}
                    alt="Download"
                    className={classes.actionIcon}
                  />
                </Grid>
                <Grid item xs>
                  <Typography
                    variant={
                      smallMode ? "body_strong_black" : "body_strong_lg_black"
                    }
                  >
                    Download your results to share with your healthcare
                    provider.
                  </Typography>
                </Grid>
              </Grid>
              <Grid
                item
                container
                spacing={2}
                alignItems="center"
                id="talk-with-provider"
              >
                <Grid item>
                  <img
                    src={TalkIcon}
                    alt="Talk"
                    className={classes.actionIcon}
                  />
                </Grid>
                <Grid item xs>
                  <Typography
                    variant={
                      smallMode ? "body_strong_black" : "body_strong_lg_black"
                    }
                  >
                    Talk with your healthcare provider(s) about what you should
                    do next for your health screenings and create a prevention
                    plan.
                  </Typography>
                </Grid>
              </Grid>
              <Grid
                item
                container
                spacing={2}
                alignItems="center"
                id="share-results"
              >
                <Grid item>
                  <img
                    src={ShareIcon}
                    alt="Share"
                    className={classes.actionIcon}
                  />
                </Grid>
                <Grid item xs>
                  <Typography
                    variant={
                      smallMode ? "body_strong_black" : "body_strong_lg_black"
                    }
                  >
                    Share your test results with your family because they may
                    also be at risk. Information about family testing can be
                    found at{" "}
                    <a
                      className={classes.faqLink}
                      href="https://www.invitae.com/us/providers/follow-up-testing"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Invitae
                    </a>
                    .
                  </Typography>
                </Grid>
              </Grid>
              <Grid
                item
                container
                spacing={2}
                alignItems="center"
                id="read-faq"
              >
                <Grid item>
                  <img
                    src={QuestionsIcon}
                    alt="Questions"
                    className={classes.actionIcon}
                  />
                </Grid>
                <Grid item xs>
                  <Typography
                    variant={
                      smallMode ? "body_strong_black" : "body_strong_lg_black"
                    }
                  >
                    Have more questions?{" "}
                    <a href="#faq" className={classes.faqLink}>
                      Click here
                    </a>{" "}
                    to read some questions others have asked us.
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default WhatsNextBox;
